import isStandaloneDisplay from "~/pwa/isStandaloneDisplay";
import readAuthReturnTo from "~/pwa/readAuthReturnTo";
import sessionStore from "~/pwa/sessionStore";

const STORAGE_KEY = "ws.launchPending";
const PENDING = "pending";
const DONE = "done";
const AUTH_CALLBACK_PATH = "/oauth-redirect";

const startsAtLauncher = (): boolean => {
	const { pathname, search } = window.location;
	if (pathname === "/") return true;
	if (pathname !== AUTH_CALLBACK_PATH) return false;
	const returnTo = readAuthReturnTo(search);
	return returnTo === null || returnTo === "/";
};

const launchSession = {
	begin: (): void => {
		if (typeof window === "undefined" || sessionStore.read(STORAGE_KEY) !== null || !isStandaloneDisplay()) return;
		sessionStore.write(STORAGE_KEY, startsAtLauncher() ? PENDING : DONE);
	},
	complete: (): void => {
		if (sessionStore.read(STORAGE_KEY) === PENDING) sessionStore.write(STORAGE_KEY, DONE);
	},
	isPending: (): boolean => sessionStore.read(STORAGE_KEY) === PENDING
};

export default launchSession;
